import {Component, Inject} from '@angular/core';
import {MatIconRegistry} from "@angular/material/icon";
import {DomSanitizer} from "@angular/platform-browser";
import {DOCUMENT, ViewportScroller} from '@angular/common';
import {NavigationEnd, Router} from '@angular/router';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {ThemeService} from "./_services/theme.service";


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    title: string = 'explain';
    confetti: boolean = false;

    constructor(private matIconRegistry: MatIconRegistry,
                private domSanitizer: DomSanitizer,
                private router: Router,
                private viewportScroller: ViewportScroller,
                protected themeService: ThemeService,
                @Inject(DOCUMENT) private document: Document
    ) {
        this.setViewportHeightVariable();
        window.addEventListener('resize', (): void => this.setViewportHeightVariable());

        this.matIconRegistry.addSvgIcon(
            `thumbtackIcon`,
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/push_pin.svg")
        );
        this.matIconRegistry.addSvgIcon(
            `unPinIcon`,
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/unpin.svg")
        );

        this.codeInput(async (): Promise<void> => {
            alert('You have found the secret disco community!');
            const matIcon: HTMLCollectionOf<Element> = document.getElementsByClassName('mat-icon');
            const initial: HTMLCollectionOf<Element> = document.getElementsByClassName('initial');
            const logo: HTMLCollectionOf<Element> = document.getElementsByClassName('companyImg');
            const miniInitial: HTMLCollectionOf<Element> = document.getElementsByClassName('miniInitial');
            addClass(matIcon)
            addClass(initial)
            addClass(miniInitial)
            addClass(logo)
            setInterval((): void => {
                this.themeService.savePrimaryColor(getRandomColor())
                this.themeService.saveAccentColor(getRandomColor());
                this.confetti = true;
            }, 300);
        });

        function getRandomColor(): string {
            const letters = '0123456789ABCDEF';
            let color: string = '#';
            for (let i: number = 0; i < 6; i++) {
                color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
        }

        function addClass(elements: HTMLCollectionOf<Element>): void {
            for (let index: number = 0; index < elements.length; index++) {
                elements.item(index)?.classList.add("rotate")
            }
        }

        this.router.events
            .pipe(takeUntilDestroyed())
            .subscribe(event => {
                if (event instanceof NavigationEnd) {
                    if (history.state.navigationId && history.state.navigationId !== 1) {
                        this.viewportScroller.scrollToPosition([0, 0]);
                    }
                }
            });
    }

    setViewportHeightVariable(): void {
        const vh: number = window.innerHeight * 0.01;
        this.document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    codeInput(cb: any): void {
        var input: string = '';
        var key: string = '38384040373937396665';
        document.addEventListener('keydown', function (e): any {
            input += ("" + e.keyCode);
            if (input === key) {
                return cb();
            }
            if (!key.indexOf(input)) return;
            input = ("" + e.keyCode);
        });
    }
}
